<template>
  <b-modal
    id="member-details-modal"
    ref="member-details-modal"
    size="xs-size"
    title="Update user details"
    modal-class="member-details-modal"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div>
      <div class="modal-head">
        <h2 class="modal-title">{{ label.get("update_user_details") }}</h2>
      </div>
      <div class="details-form">
        <div class="content-wrapper">
          <div class="form-row">
            <label>{{ label.get("name") }}</label>
            <div class="input-wrapper">
              <input
                ref="name"
                v-model="nameInput"
                type="text"
                name="name"
                :placeholder="label.get('name')"
                maxlength="50"
                class="name-input"
                autofocus
              />
            </div>
          </div>
          <div class="error-wrapper">
            <span
              v-if="nameError && !$v.nameInput.required"
              class="error-message"
            >
              {{ label.get("name_is_required") }}
            </span>
          </div>
          <!--          <div v-if="showCustomPassportLicenseNumber">
            <div class="form-row">
              <label>{{label.get('license_nr')}}</label>
              <div class="input-wrapper">
                <input
                        v-model="license_number"
                        type="text"
                        class="input"
                        autofocus
                />
              </div>
            </div>
            <div class="form-row">
              <label>{{label.get('nie_pass')}}</label>
              <div class="input-wrapper">
                <input
                        v-model="passport_number"
                        type="text"
                        class="input"
                        autofocus
                />
              </div>
            </div>
          </div>-->
        </div>
        <div class="modal-footer">
          <button type="reset" class="atto-btn cancel" @click="close">
            {{ label.get("cancel") }}
          </button>
          <button
            type="submit"
            class="atto-btn submit"
            :disabled="disableSubmitButton"
            @click="submit"
          >
            {{ label.get("update") }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import MemberService from "../services/MemberService";
export default {
  name: "MemberDetailsComponent",
  props: {
    id: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
      default: "",
    },
    licenseNumber: {
      type: String,
      default: "",
    },
    passportNumber: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      nameInput: this.name,
      nameError: false,
      disableSubmitButton: false,
      license_number: this.licenseNumber,
      passport_number: this.passportNumber,
      showCustomPassportLicenseNumber: false, //this.$store.state.showCustomPassportLicenseNumber
    };
  },
  validations: {
    nameInput: {
      required,
      maxLength: maxLength(50),
    },
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs["member-details-modal"].show();
    this.focusField();
  },
  methods: {
    close() {
      this.$root.$emit("hideMemberDetailsModal");
    },
    focusField() {
      const _this = this;
      this.$nextTick(() => {
        _this.$refs.name.focus();
      }, 100);
    },
    submit(event) {
      event.preventDefault();
      event.stopPropagation();
      this.nameError = false;
      this.$v.nameInput.$touch();
      if (this.$v.nameInput.$invalid) {
        this.nameError = true;
        return false;
      }

      if (
        this.name === this.nameInput &&
        this.passport_number === this.passportNumber &&
        this.license_number === this.licenseNumber
      ) {
        this.$root.$emit("hideMemberDetailsModal");
        return;
      }

      const data = {
        member_id: this.id,
        name: this.nameInput,
        passport_number: this.passport_number,
        license_number: this.license_number,
      };
      this.disableSubmitButton = true;
      MemberService.changeMemberName(data)
        .then((response) => {
          this.$awn.success(response.data.message);
          this.$root.$emit("hideMemberDetailsModal", {
            name: this.nameInput,
            passport_number: this.passport_number,
            license_number: this.license_number,
          });
        })
        .catch(() => {
          this.nameError = true;
          this.disableSubmitButton = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  .modal-head {
    padding: 40px 40px 16px;
  }
  .modal-content {
    .modal-body {
      .content-wrapper {
        padding: 16px 40px 0;
      }
    }
  }
  .modal-footer {
    padding: 8px 40px 40px;
  }
}
.details-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;

  .form-row {
    display: flex;
    flex-direction: column;
    margin: 0 0 32px 0;

    label {
      display: inline-flex;
      font-size: 0.6875rem;
      line-height: 0.8125rem;
      font-family: $roboto-font;
      font-weight: $roboto-medium;
      color: #999999;
      letter-spacing: 0.6px;
      text-transform: uppercase;
      margin-bottom: 4px;
    }

    .input-wrapper {
      display: flex;
      width: 100%;
      position: relative;
      flex-direction: row;
      padding: 10px 0 10px 12px;
      border: 2px solid #efefef;
      height: 40px;

      input {
        flex-grow: 1;
        border: 0;
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-family: $roboto-font;
        font-weight: 400;
        color: $atto-font-color;
        @include style-placeholder(#999);
      }

      i.tick {
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
      }

      &:focus-within {
        border-color: #00b9cb;
      }

      &.has-error {
        border-color: #e05656;
      }
    }

    .error-message {
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      color: #e05656;
    }

    &.row-align {
      flex-direction: row;

      .col {
        padding: 0;
      }
    }

    &.submit-wrap {
      margin-top: 28px;
      margin-bottom: 0;
    }

    .submit-form {
      width: 320px;
      max-width: 100%;
      justify-content: center;
      text-transform: uppercase;
    }
  }
}
</style>
